import React, {useEffect, useRef, useState} from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import {list, listUserClub} from '../../../lib/api/club';
import {add, listPlayers} from '../../../lib/api/termination';
import {format} from "date-fns";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import {months} from "../../../data/common";

export function Add({ onClose, onSave }) {
  //console.log('initEntities',initEntities)
  const [club, setClub] = useState([]);
  const [clubSpec, setClubSpec] = useState([]);
  const [item, setItem] = useState({});
  const [selectedClubId, setSelectedClubId] = useState('');
  const [selectedPlayer, setSelectedPlayer] = useState([]);
  const [transferOption, setTransferOption] = useState('');
  const [errors, setErrors] = useState({entities_id: false, players_entities_id: false})

  const [value, setValue] = useState(null);

  useEffect(() => {
    (async () => {
      console.log('entities',club)
      const _clubs = await listUserClub()
      const _rows = _clubs.map(p => ({...p, value: p.club_id, label: p.name}));
      setClub(_rows);

      const _clubsSpec = await list()
      const _rowsSpec = _clubsSpec.map(p => ({...p, value: p.club_id, label: p.name}));
      setClubSpec(_rowsSpec);
    })();
  }, []);

  const handelInput = e => {
    const { name, value, type, id } = e.target;

    // Ako je radio button, koristi mapiranje preko ID-a
    if (type === 'radio') {
      // Mapiranje id → item key
      const radioMap = {
        allow_transfer_any_club: { key: 'transfer_option', value: 'allow_transfer_any_club' },
        allow_transfer_specific_club: { key: 'transfer_option', value: 'allow_transfer_specific_club' },
        tc_exempted: { key: 'compensation_option', value: 'tc_exempted' },
        tc_paid: { key: 'compensation_option', value: 'tc_paid' }
      };

      const mapped = radioMap[id];
      if (mapped) {
        setItem(prev => ({
          ...prev,
          [mapped.key]: mapped.value
        }));

        if (mapped.key === 'transfer_option') {
          setTransferOption(mapped.value);
        }
      }
    } else {
      if (name === 'entities_id') {
        const value = e.target.value;
        setSelectedClubId(value);
        if (!value) setSelectedPlayer(null);
      }

      setItem(prev => ({
        ...prev,
        [name]: value
      }));
    }

    console.log('item', item);
  };



  const loadOptions = (inputValue, callback) => {
    if (inputValue.length < 3 || !selectedClubId) {
      return callback([]); // ne traži ništa dok nema 3 slova i izabran klub
    }

    try {
      listPlayers({name: inputValue, club_entities_id: selectedClubId})
          .then(response => {
            const options = response.map(item => ({
              value: item.entities_id,
              label: item.name + ' ('+ formatDateTime(item.date_of_birth)+')',
              players_year: item.players_year,
              is_home_club: item.is_home_club
            }));
            callback(options);
          }).catch(err => {
        console.error(err);
        callback([]);
      });

    } catch (error) {
      console.error(error);
      callback([]);
    }
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // mjeseci idu od 0
    const yyyy = date.getFullYear();

    return `${dd}.${mm}.${yyyy}`;
  }

  const handleSubmit = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    if (!validateForm(event)) return;


    console.clear();
    console.log('item',item)

    const _data = {
      ...item,
      allow_transfer_any_club: item.transfer_option === 'allow_transfer_any_club' ? 1 : 0,
      allow_transfer_specific_club: item.transfer_option === 'allow_transfer_specific_club' ? 1 : 0,
      tc_exempted: item.compensation_option === 'tc_exempted' ? 1 : 0,
      tc_paid: item.compensation_option === 'tc_paid' ? 1 : 0
    };
    if (_data.allow_transfer_any_club === 1) _data['specific_club_entities_id'] = null;

    console.log(_data);

    await add(_data);
    onSave();
    onClose();
  };



  const validateForm = event => {
    const form = event.currentTarget;
    console.log('form',form)
    console.log('form.players_entities_id.value',form.players_entities_id)
    const newErrors = {
      entities_id: !item.entities_id,
      players_entities_id: !item.players_entities_id,
      transfer_option: !item.transfer_option,
      compensation_option:
          selectedPlayer &&
          selectedPlayer.players_year >= 14 &&
          selectedPlayer.players_year <= 17 &&
          selectedPlayer.is_home_club === 1 &&
          !item.compensation_option,
    };

    if (item.transfer_option === 'allow_transfer_specific_club' && !item.specific_club_entities_id) {
      newErrors.specific_club_entities_id = true;
    }


    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="name">
                <Form.Label>Naziv</Form.Label>
                <Form.Control required type="text" name="name" value={"Prekid članstva"} disabled/>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="date_created">
                <Form.Label>Datum</Form.Label>
                <Form.Control required type="text" value={format(new Date(), 'dd.MM.yyyy')} name="date_created"
                              disabled/>
              </Form.Group>
            </Row>

            <div className="border-dashed border-bottom my-3"/>

            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="entities_id">
                <Form.Label>Klub</Form.Label>
                <Form.Select name="entities_id" required isInvalid={errors.entities_id} onChange={handelInput}>
                  <option value="">Izaberi</option>
                  {club.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo izaberite klub.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="players_entities_id">
                <Form.Label>Igrač</Form.Label>
                <AsyncSelect name="players_entities_id"
                             cacheOptions
                             defaultOptions={false}
                             loadOptions={loadOptions}
                             placeholder="Pretraži..."
                             classNamePrefix="react-select"
                             onChange={(opt, meta) => {
                               handelInput({ target: { name: 'players_entities_id', value: opt ? opt.value : null } });
                               setSelectedPlayer(opt || null);
                             }}
                             value={selectedPlayer}
                             isDisabled={!selectedClubId}
                             isClearable={true}
                />
                {errors.players_entities_id && (
                    <div className="invalid-feedback d-block">
                      Molimo izaberite igrača.
                    </div>
                )}
                <Form.Control.Feedback type="invalid">Molimo izaberite igrača.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <div className="border-dashed border-bottom my-3"/>

            <Row className="mb-3">
              <Form.Group as={Col} md="7" controlId="transfer">
                <Form.Label as="legend" column md="12" className="mb-3">
                  Ispisnica
                </Form.Label>
                <Col md="12">
                  <Form.Check
                      inline
                      type='radio'
                      id='allow_transfer_any_club'
                      label='Može da pređe u bilo koji klub'
                      name='transfer'
                      onChange={handelInput}
                  />
                  <Form.Check
                      inline
                      type='radio'
                      id='allow_transfer_specific_club'
                      label='Može da pređe u:'
                      name='transfer'
                      onChange={handelInput}
                  />
                </Col>
              </Form.Group>
              <Form.Group as={Col} md="5" controlId="specific_club_entities_id">
                <Form.Label className="mb-4">&nbsp;</Form.Label>
                <Form.Select name="specific_club_entities_id" isInvalid={errors.specific_club_entities_id} onChange={handelInput} disabled={transferOption !== 'allow_transfer_specific_club'}>
                  <option value="">Izaberi</option>
                  {clubSpec.map(p => (
                      <option key={p.entities_id} value={p.entities_id}>
                        {p.name}
                      </option>
                  ))}
                </Form.Select>
              </Form.Group>
              {errors.transfer_option && (
                  <div className="text-danger small mt-1">Molimo izaberite jednu od opcija za ispisnicu.</div>
              )}
            </Row>

            {selectedPlayer &&
                selectedPlayer.players_year >= 14 &&
                selectedPlayer.players_year <= 17 &&
                selectedPlayer.is_home_club === 1 && (
                    <>
                      <div className="border-dashed border-bottom my-3"/>
                      <Row className="mb-3">
                        <Form.Group as={Col} md="7" controlId="compensation">
                          <Form.Label as="legend" column md="12" className="mb-3">
                            Trening kompenzacija
                          </Form.Label>
                          <Col md="12">
                            <Form.Check
                                inline
                                type='radio'
                                id='tc_exempted'
                                label='Ne mora da se plati'
                                name='compensation'
                                onChange={handelInput}
                            />
                            <Form.Check
                                inline
                                type='radio'
                                id='tc_paid'
                                label='Plaćena'
                                name='compensation'
                                onChange={handelInput}
                            />
                          </Col>
                        </Form.Group>
                      </Row>
                      {errors.compensation_option && (
                          <div className="text-danger small mt-1">Molimo izaberite jednu za trening kompenzaciju.</div>
                      )}
                    </>
                )}
            <div className="border-dashed border-bottom my-3"/>
            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
